module.exports = __webpack_public_path__ + "img/moonraker_verification_code.png";